module.exports = __webpack_public_path__ + "img/Meeting_record-B.60577ef5.svg";